import { createFileRoute } from '@tanstack/react-router';

import { LegalEntities } from '@/features/legal-entities/LegalEntities';
import { buildHead } from '@/utils/html';

export const Route = createFileRoute('/_authenticated/entities/')({
  component: LegalEntities,
  head: () => buildHead('entities'),
});
